<template>
  <v-row align="center" justify="center">
    <v-col cols="12">
      <v-card>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-row align="center" justify="center">
              <v-col cols="10" style="padding: 0 12px;">
                <v-img src="../assets/images/register.png" aspect-ratio="1.2" contain></v-img>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="10" style>
                <div class="text-center big-title">
                  Não fique
                  <a>fora de jogo.</a>
                </div>
                <div
                  class="text-center small-title"
                >Este conteúdo é exclusivo da subscrição premium, subscreve e entra em jogo connosco.</div>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-col cols="10">
                <v-btn block large depressed color="primary" to="/configuracoes">Subscrever</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>
.big-title {
  font-family: Gilroy-SemiBold;
  font-size: 20px;
  line-height: 24px;
}
.small-title {
  font-family: Gilroy-SemiBold;
  color: #6d818f;
  font-size: 14px;
  line-height: 16px;
}
</style>

<script>
export default {
  name: "PremiumContent"
};
</script>